export const DEFAULT_DAYS_CYCLE = 30;
export const DEFAULT_QUANTITY_CYCLE = 3;
